import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import Query from 'dashboard-services/api/Query';

import getApiConfig from 'api/ApiConfig';
import { CurvesUtils } from 'utils';

import seriesHooks from '../series';

export default (() => {
  const defaultCurves = () => Promise.resolve().then(() => ({
    symbols: [
      {
        label: "Product",
        filterKey: CurvesUtils.PRODUCT,
        type: DataStorageEnums.KEY_TYPE.METADATA
      }
    ]
  }))

  const useEnvCurves = ({ source, localSource }) => {
    const dispatch = useDispatch(),
      getQueryBuilder = useCallback(() => new Query.Builder(dispatch(getApiConfig()))
        .withFetching(false)
        .withShouldDisplayError(false)
      , [dispatch])
    const getCurvesConfig = seriesHooks.useReturnConfigFileContent({
      getQueryBuilder,
      fileName: "curvesConfig.json",
      getDefaultFile: defaultCurves
    })

    return useCallback(() => getCurvesConfig().then(config => config?.[source] || config?.[localSource] || defaultCurves()), [getCurvesConfig, localSource, source])
  }

  return {
    useEnvCurves
  }
})()
